"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _getEarlyRequesterResultPromise = _interopRequireDefault(require("settings-ui-sdk/getEarlyRequesterResultPromise"));

var COMPANY_PROPERTIES_URI = 'properties/v1/companies/properties';
var CONTACT_PROPERTIES_URI = 'properties/v1/contacts/properties';
var PRODUCT_PROPERTIES_URI = 'properties/v1/products/properties';

var PropertiesAPI =
/*#__PURE__*/
function () {
  function PropertiesAPI() {
    (0, _classCallCheck2.default)(this, PropertiesAPI);
  }

  (0, _createClass2.default)(PropertiesAPI, null, [{
    key: "getContactProperties",
    value: function getContactProperties() {
      return _apiClient.default.get(CONTACT_PROPERTIES_URI);
    }
  }, {
    key: "getCompanyProperties",
    value: function getCompanyProperties() {
      return _apiClient.default.get(COMPANY_PROPERTIES_URI);
    }
  }, {
    key: "getProductProperties",
    value: function getProductProperties() {
      return (0, _getEarlyRequesterResultPromise.default)('product-properties') || _apiClient.default.get(PRODUCT_PROPERTIES_URI);
    }
  }]);
  return PropertiesAPI;
}();

exports.default = PropertiesAPI;
module.exports = exports.default;